<template>
    <div class="question xs12 sm6 md4 lg3">

        <v-layout row wrap>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img @click="previousQuestion"  class="ui-btn" src="icons/qa/ui/btnBackward.svg" />
                    </div>
                </div>
            </v-flex>
            <v-flex xs8 sm10>
                <h3 v-if="currIndexString=='2' && user.name!=''">{{ questionToShow.question.text.formal.substring(0,questionToShow.question.text.formal.length-1) }}, {{ user.name }}?</h3>
                <h3 v-else>{{ questionToShow.question.text.formal }}</h3>
            </v-flex>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img v-if="questionToShow.options.expected!='singleChoice' && thisQuestionFinished==true" @click="nextQuestion"  class="ui-btn" src="icons/qa/ui/btnForward.svg" />
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <div v-if="questionToShow.options.type=='input' && currIndexString!='2'">
            <v-img :src="'/icons/qa/'+questionToShow.icon+'.svg'" class='dezent' color="primary" height="100%" width="100"  position="center center"></v-img>
            <v-text-field
                    v-model="answer"
                    color="primary"
                    ref="inputField"
                    @keyup.enter="handleKeyUpEnterInInputField"
            ></v-text-field>
        </div>
        <div v-if="questionToShow.options.type=='input' && currIndexString=='2'">
            <v-img :src="'/icons/qa/'+questionToShow.icon+'.svg'" class='dezent' color="primary" height="100%" width="100"  position="center center"></v-img>
            <v-select
                    :items="birthYearItems"
                    ref="birthYearField"
                    v-model="answer"
                    @change="nextQuestion"
            ></v-select>
        </div>
        <v-container
                v-if="questionToShow.options.type=='select' && questionToShow.options.expected=='singleChoice'"
                >
            <v-layout row wrap
                      justify-center
                      align-top>
                <v-radio-group
                        v-for="option in questionToShow.options.items"
                        :key="option.index"
                        v-model="singleChoiceSelection"
                        @click="checkForChildQuestions(option);nextQuestion(200);"
                        :mandatory="true">
                    <v-img
                            :src="'/icons/qa/'+option.icon+'.svg'"
                            color="primary"
                            :class="'dezent' + selected(option.index)"
                            height="100px"
                            min-width="100"
                            :contain="true"
                            position="center bottom"
                            style="background-size: contain !important; cursor: pointer;"
                            @click="singleChoiceSelection={'index':option.index,'icon':option.icon};checkForChildQuestions(option);nextQuestion(200)"
                    ></v-img>
                    <v-radio :label="option.label.formal" :value="option"
                    ></v-radio>
                </v-radio-group>
            </v-layout>
        </v-container>

        <v-container
                v-if="questionToShow.options.type=='select' && questionToShow.options.expected=='multipleChoice'"
                fluid grid-list-sm>
            <v-layout row wrap
                      justify-center
                      align-top>
                <div
                        v-for="option in questionToShow.options.items"
                        :key="option.index">
                    <v-img
                            :src="'/icons/qa/'+option.icon+'.svg'"
                            color="primary"
                            :class="'dezent' + selected(option.index)"
                            height="100"
                            min-width="100px"
                            :contain="true"
                            position="center bottom"
                            style="background-size: contain !important; cursor: pointer;"
                    ></v-img>
                    <v-checkbox
                            v-model="multipleChoiceSelection"
                            :label="option.label.formal"
                            :value="option"
                    >
                    </v-checkbox>
                </div>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapState } from "vuex";

    export default {
        name: "Question",
        props: ['questionIndexString'],
        data() {
            return {
                childQuestionNextIndex: "",
                selectedIndexes: [],
                birthYearItems: [],
                singleChoiceSelectionTEST: {},
                testObject: {name: 'Otto', age: '47'},
                testArray: []
            }
        },
        computed: {
            currIndexString(){
                return this.questionIndexString;
            },
            prevIndexString(){
                return this.questionToShow.prevIndexString;
            },
            nextIndexString(){
                let s = this.questionToShow.nextIndexString;
                let check = s.split('/')
                if(check.length==1) { return s; }
                // Konvention: eventuelle Unterfragen stehen VOR dem Slash, z.B. "8.2.1/9"
                let subCheck = check[0].substring(0,3); // z.B. "8.2"
                // Im Beispiel: wenn Eintrag "8.2" gewählt wurde, mache mit Frage 8.2.1 weiter
                if(this.$store.getters['qa/getOptionIsInAnswers'](subCheck)){
                    return check[0];
                }
                return check[1];
            },
            answer: {
                get(){
                    return this.$store.getters['qa/getAnswerInputText'](this.currIndexString);
                },
                set(value){
                    this.$store.dispatch("qa/setAnswer", {
                        index: this.questionToShow.index,
                        text: value
                    });
                }
            },
            singleChoiceSelection: {
                get(){
                    return this.$store.getters['qa/getSingleChoiceSelectionValue'](this.questionToShow.index);
                },
                set(value){
                    this.$store.dispatch("qa/setSingleChoiceSelection", {
                        index: this.questionToShow.index,
                        selection: value
                    });
                    this.removeChildrenWithoutParents();
                }
            },
            multipleChoiceSelection: {
                get(){
                    return this.$store.getters['qa/getMultipleChoiceSelectionValue'](this.currIndexString);
                },
                set(value){
                    this.$store.dispatch("qa/setMultipleChoiceSelection", {
                        index: this.currIndexString,
                        selection: value
                    });
                    this.removeChildrenWithoutParents();
                    /*
                    this.$store.dispatch("qa/storeMultipleSelection",{
                        index: this.questionIndexString,
                        selection: this.multipleChoiceSelection
                    });  */
                }
            },
            questionToShow(){
                return this.question(this.currIndexString);
            },
            selected(index){
                return index => this.selectedIndexes[index] === true ? 'selected' : '';
            },
            topLevelIndex(){
                let indexes = this.currIndexString.split('.');
                return indexes[0];
            },
            thisQuestionFinished(){
                if((this.questionToShow.options.type=='input') && this.answer.length==0) { return false; }

                return true;
            },
            ...mapGetters("qa", {
                answer_tmp: "getAnswer",
                question: 'getQuestionByIndexString',
                user: 'getUser',
                hobbies: 'getMultipleChoiceSelectionValue'
            })
        },
        methods: {
            handleClickOnSelect(index){
                if( this.selectedIndexes[index] == undefined){
                    this.selectedIndexes[index] = true;
                    return;
                }
                this.selectedIndexes[index] = !this.selectedIndexes[index];
            },
            handleKeyUpEnterInInputField(){
                if(this.thisQuestionFinished) {
                    this.nextQuestion();
                }
            },
            previousQuestion(){
                if(this.prevIndexString == ""){
                    this.$router.push('willkommen');
                }
                this.$emit('newQuestionIndex',this.prevIndexString);
                /*
                this.currIndexString = this.questionToShow.prevIndexString;
                this.$emit('newQuestionIndex',this.topLevelIndex);
                if(this.questionToShow.options.type=='input'){
                    this.$refs.inputField.focus();
                }
                */
            },
            nextQuestion(delay=0){

                // this.updateCloudIconColors();
                if(this.nextIndexString == "" && this.childQuestionNextIndex == ""){
                    this.$emit('noMoreQuestions');
                    return;
                }
                if(this.childQuestionNextIndex != ""){
                    this.$emit('newQuestionIndex',this.childQuestionNextIndex);
                    this.updateFocus();
                    return;
                }
                let hobbiesAnswer = this.hobbies('8');

                if(this.currIndexString=='8' && hobbiesAnswer.includes('8.2')) {
                    this.$emit('newQuestionIndex','8.2.1');
                    this.updateFocus();
                    return;
                }
                if(this.currIndexString=='2'){
                    delay = 0;
                }
                let self = this;
                // short delay to give visual feedback to the user
                setTimeout(()=>{ self.$emit('newQuestionIndex',self.nextIndexString); },delay);

                /*
                this.currIndexString = this.questionToShow.nextIndexString;
                this.$emit('newQuestionIndex',this.topLevelIndex);
                if(this.questionToShow.options.type=='input'){
                    this.$refs.inputField.focus();
                }
                */
            },
            removeChildrenWithoutParents(){
                this.$store.dispatch('qa/removeResponseWithoutParents');
            },
            checkForChildQuestions(option){
                if(option.childQuestions!=undefined && option.childQuestions.length > 0) {
                    this.childQuestionNextIndex = option.childQuestions[0].currIndexString;
                    return;
                }
                this.childQuestionNextIndex = "";
            },
            updateCloudIconColors(){
                this.$store.dispatch("qa/updateCloudIconColors");
            },
            storeMultipleSelection(){
                this.$store.dispatch("qa/storeMultipleSelection",{
                    index: this.questionIndexString,
                    selection: this.multipleChoiceSelection
                });
            },
            resetFields() {
                Object.assign(this.$data, this.$options.data.call(this));
            },
            updateFocus(){
                if(this.questionToShow.options.type=='input'  && this.currIndexString=='1'){
                    this.$refs.inputField.focus();
                }
                if(this.questionToShow.options.type=='input'  && this.currIndexString=='2'){
                    this.$refs.birthYearField.focus();
                }
            }
        },
        mounted(){
            let aktYear = new Date().getFullYear();
            let start = aktYear - 17;
            let end = aktYear - 99;
            for(let i=start; i>end; i--){
                this.birthYearItems.push(i+'');
            }
            this.updateFocus();
        }
    }
</script>

<style>
    h3 {
        font-size: 32px;
        line-height: 1.5em;
    }
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
    }
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) .v-input__control {
        border-radius: 3em;
        padding: 0.5em 2em 0 2em;
        text-align: center;
    }
    .theme--dark.v-input:not(.v-input--is-disabled):not(.v-input--switch) input,
    .theme--dark.v-input:not(.v-input--is-disabled) textarea {
        color: #002EA7 !important;
        font-size: 18px;
    }

    input, .v-select__selection {
        text-align: center;
        font-size: 18px !important;
        color: #002EA7 !important;
        display: inline !important;
        flex: none !important;
    }

    div.v-select .v-input__control{
        padding-top: 0.75em !important;
        padding-bottom: 0.75em !important;
    }
    .v-select__selection {
        width: 100%;
    }

    .v-input--selection-controls:not(.v-input--switch) {
        display: inline !important;
        flex: none !important;
    }

    div.v-select__selections:not(.v-input--switch) {
        padding-top: 0 !important;
    }
    div.v-select__selections input[readonly='readonly'] {
        max-height: 1px;
        max-width: 1px;
        padding: 0;
        margin: 0;
    }
    .v-input__slot {
        margin-bottom: 0;
    }
    div.v-input[role='combobox'] .v-input__control {
        padding-top: 0;
        padding-bottom: 0;
    }

    div.v-input[role='combobox'] .v-input__control .v-text-field__details {
        display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot::before {
        border: none !important;
    }
    .v-text-field > .v-input__control > .v-input__slot {
        transform: translateY(+7%);
    }
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) .v-input__control,
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) .v-input__control:focus,
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) .v-input__control:active,
    .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch) .v-input__control::selection
    {
        background-color: #97D700 !important;
    }
    .v-input__control {
        background-color: inherit;
    }

    .v-image {
        margin: auto;
    }
    .v-image.dezent {
        opacity: 0.4;
        transform: scale(0.8);
    }
    div.question button.v-btn {
        border-radius: 3em !important;
        padding: 0.5em 2em 0 2em;
        background-color: #CCD5ED !important;
    }
    .v-btn__content {
        color: white !important;
    }
    button.v-btn.selected {
        background-color: #42b983;
    }

    img.ui-btn {
        cursor: pointer;
    }
    img.ui-btn:disabled {
        opacity: 0.5;
        cursor: default;
    }

    /* Radios */
    .v-radio {
        background-color: none;
    }
    .v-radio label.v-label, .v-input--checkbox label.v-label {
        background-color: #CCD5ED !important;
        border-radius: 3em !important;
        padding: 1em 2em;
        margin-top: 1em;
        text-align: center;
        font-size: 18px !important;
        color: #002EA7 !important;
    }
    .v-radio.accent--text label.v-label, .v-input--checkbox.v-input--is-label-active label.v-label{
        background-color: #97D700 !important;
    }
    div.v-input--selection-controls__input {
        display: none;
     }
    div.v-input--switch div.v-input__control div.v-input__slot div.v-input--selection-controls__input {
        display: inline-flex;
    }
    div.v-input--switch {
        right: -24px;
        position: absolute;
    }

    .v-input--checkbox .v-input__control {
        margin-right: 15px;
    }
</style>
